var View = require('views/base/view');
var ModuleLinkView = require('./module-link-view');
var AssessmentService = require('services/assessment-service');

var ModuleItemView = View.extend({
  noWrap: true,
  regions: {
    'module-link': '.module-link'
  },
  template: require('./templates/module-item'),
  initialize: function(options) {
    View.prototype.initialize.apply(this, arguments);
    var self = this;
    this.model.set('use_div', options.useDiv);
    this.model.set('moduleClass', options.moduleClass);
    this.on('addedToParent', function() {
      self.container = self.el;
      var linkView = new ModuleLinkView({
        model: self.model,
        region: 'module-link',
        moduleTemplate: options.moduleTemplate
      });
      self.subview('moduleLink', linkView);
    });
  },
  getTemplateData: function() {
    var completedPerc = this.model.percentCompleteTotal();
    this.model.set('percentComplete', Math.round(completedPerc * 100));
    switch(completedPerc) {
      case 1:
        this.model.set('status', 'completed');
        break;
      case 0:
        this.model.set('status', 'not-started');
        break;
      default:
        this.model.set('status', 'in-progress');
        break;
    }

    if(this.model.get('assessment_slug')) {
      this.model.set('assessmentStatus', AssessmentService.getAssessmentStatus(this.model.get('assessment_slug')));
      this.model.set('score', AssessmentService.getBestScore(this.model.get('assessment_slug')));
    }
    if(this.model.get('locked')) {
      this.model.set('lockState', 'locked');
    } else {
      var canReview = this.model.get('canReview') !== false;
      var completed = this.model.get('completed');
      if(this.model.get('assessmentStatus') && this.model.get('assessmentStatus') !== 'passed') {
        completed = false;
      }
      if(!completed) {
        this.model.set('lockState', 'unlocked');
      }
      else if(completed && !canReview) {
        this.model.set('lockState', 'locked');
      }
      else {
        // completed && canReview
        this.model.set('lockState', 'unlocked');
      }
    }

    this.model.set('locked', this.model.get('lockState') === 'locked');
    this.model.set('unlocked', !this.model.get('locked'));
    this.model.set('groupClass', 'group-' + this.model.get('groupId') + '-module');
    return this.model.serialize();
  }
});

module.exports = ModuleItemView;
